
import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Confidentiality_table from "./confidentiality_table/Confidentiality_table";

function Confidentiality() {
  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Confidentiality" />
        </div>

        <div className="imperiality_table_div">
          <Confidentiality_table />
        </div>
      </section>
    </>
  );
}

export default Confidentiality;
